<template>
  <div>
    <title-panel
      :button-label="t('checkBotConfigsManagement.addConfiguration')"
      :no-counter="true"
      :on-button-click="handleAddConfigButtonClick"
    >
      {{ t('checkBotConfigsManagement.checkBot') }}
    </title-panel>
    <check-bot-configs-table :project-id="projectId" :supplier-id="supplierId" />
    <add-check-bot-config-modal
      ref="modalRef"
      :project-id="projectId"
      :supplier-id="supplierId"
    />
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n';
  import CheckBotConfigsTable from '@/components/CheckBotConfigsTable/CheckBotConfigsTable.vue';
  import AddCheckBotConfigModal from '@/components/AddCheckBotConfigModal/AddCheckBotConfigModal.vue';
  import { ref } from 'vue';

  const { t } = useI18n();

  defineProps<{
    projectId: string;
    supplierId?: string;
  }>();

  const modalRef = ref<InstanceType<typeof AddCheckBotConfigModal> | null>(
    null,
  );
  function handleAddConfigButtonClick() {
    modalRef.value?.show();
  }
</script>

<style lang="scss" scoped>
  .title-panel {
    margin-top: $tab-view-margin-top;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
</style>
